import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Plus from "../../../../assets/Icon/Plus"; 
import { useTranslation } from 'react-i18next';

const AddPermissionModal = ({ permissionService, defaultPermission }) => {
    const {t} = useTranslation();
    const permissionResetData = {
        id: 0,
        name: "",
        description: "", 
    }

    const [newPermission, setNewPermission] = useState(permissionResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validatePermission = (permission) => {
        const messages = {};

        if (permission.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სახელი', isValid: false };
        }
 
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const reValidate = () => {
        const isValidate = validatePermission(newPermission)

    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validatePermission(newPermission)
        }
    }, [newPermission, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const saveHandle = () => {

        const isValidate = validatePermission(newPermission)

        if (isValidate === true) {
            permissionService.add(newPermission)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true)
        }
 
    };

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setNewPermission(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true)
        setIsFirstValidated(false)
        setNewPermission(permissionResetData)
    } 
    
    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>
                {t('Add')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> {t('Add')}
                    </h3>
                </div>
 
                    <div className={cl.groupInput}> 
                        <input type="textS"
                            className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                            id="name" name="name" value={newPermission.name} onChange={handleClientChange} autoComplete="off" />
                        <label htmlFor="name">{t('Name')}</label>
                    </div>

                    <div className={cl.groupInput}> 
                        <input type="textS"
                            className={validates && validates.description ? cl.input + ' ' + cl.errorInput : cl.input}
                            id="description" name="description" value={newPermission.description} onChange={handleClientChange} autoComplete="off" />
                        <label htmlFor="description">{t('Description')}</label>
                    </div>
 
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Save')}</span>
            </Modal>
        </div>
    );
};

export default AddPermissionModal;